import { useEffect, useState } from "react";
import InputFilterBox from "../InputFilterBox/web"
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { getLabelSurfaceRange } from "src/utils/Functions";
import './styles.less'
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { SurfaceRange } from "shared-components/Components/Filters/SurfaceRange/web";

export const RangeSurface = ({show}) => {
    if (!show) return null;
    
    const { filters, filtersTags } = useFilters();
	const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
    const [rangeSurfaceDescription, setRangeSurfaceDescription] = useState("");

    useEffect(() => {
        const label: string = getLabelSurfaceRange(filtersTags?.m2Min, filtersTags?.m2Max);
        
        setRangeSurfaceDescription(label)
    }, [filtersTags?.m2Min, filtersTags?.m2Max])

    const handleCleanFilter = () => {
        const valuesToReset = {
            m2Min: null,
            m2Max: null,
        }

        changeFiltersAndUpdateURL(valuesToReset)
    }

    return (
        <InputFilterBox
            active={filters?.m2Min > 0 || filters?.m2Max > 0}
            label={rangeSurfaceDescription}
            customWidth={280}
            onCancelFilter={handleCleanFilter}
            scrollable
        >
            <div className="optionList add-padding remove-hr">
                <SurfaceRange
					filterChanged={changeFiltersAndUpdateURL}
					show={show}
				/>
            </div>
        </InputFilterBox>
    )
}